var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderComponent)?_c('div',{attrs:{"id":"eventList"}},[_c('div',{staticClass:"content-body-container col-md-12"},[_c('eventCom',{attrs:{"paramTourData":_vm.passTourData}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }